"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformToMangopayName = transformToMangopayName;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformToMangopayName(billingInformation) {
    return ((billingInformation.type !== legacy_enums_1.BillingInformationType.Natural && billingInformation.bussinessName) ||
        `${billingInformation.firstName} ${billingInformation.lastName}`);
}
//# sourceMappingURL=transformToMangopayName.js.map